/**
 * Website forms post to a same-origin endpoint (/api/forms/<name>) that is
 * served on the live server by deploy/mailer and proxied through
 * OpenLiteSpeed. The mailer verifies the reCAPTCHA token server-side and
 * hands the message to the local MTA.
 *
 * For `gatsby develop` set GATSBY_FORMS_API=http://127.0.0.1:3200 (and add
 * http://localhost:3005 to ALLOWED_ORIGINS in the mailer's .env).
 */
export type FormName = 'enquiry' | 'newsletter' | 'demo'

const base = (process.env.GATSBY_FORMS_API || '').replace(/\/$/, '')

export const formEndpoint = (name: FormName): string => `${base}/api/forms/${name}`

/** Name of the hidden honeypot field; the mailer silently drops any submission that fills it. */
export const HONEYPOT_FIELD = 'website'
